import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import HeaderCard from '../../Common/HeaderCard';
import DataTableComponent from './DataTableComponent';

const DataTablesContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs parent='Table' title='Data Tables' pageTitle='Data Tables' />
      <Row>
        <Col sm='12'>
          <Card>
            <HeaderCard title='Select Multiple and Delete Single Data' />
            <CardBody className='data-tables'>
              <DataTableComponent />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DataTablesContainer;
